
import {Saseung3HangulService} from "./saseung3-hangul.service";

export const Saseung3HangulInjectables: Array<any> = [
  {
    provide: Saseung3HangulService,
    useClass: Saseung3HangulService,
  },
];
